import {TimeoutId} from '@colonist/types'
import {createDivIn, setElementOnClick} from '../ui_utils/DomUtils'
import {socket} from '../EntryShared'

export class UISocketMonitor {
    private container: HTMLElement
    private updateTimer: TimeoutId | undefined

    private mediumLatency: HTMLElement
    private highLatency: HTMLElement
    private droppedLatency: HTMLElement
    private reconnects: HTMLElement
    private latency: HTMLElement

    start() {
        this.createElements()
        this.updateTimer = setInterval(() => this.update(), 100)
        socket.monitor.activate()
    }

    stop() {
        clearInterval(this.updateTimer)
        this.container.remove()
    }

    private createElements() {
        this.container = createDivIn(document.body, '')
        this.container.style.position = 'absolute'
        this.container.style.backgroundColor = 'gray'
        this.container.style.display = 'flex'
        this.container.style.opacity = '0.9'
        this.container.style.top = '5px'
        this.container.style.left = '5px'
        this.container.style.zIndex = '99999999'
        setElementOnClick(this.container, () => {
            // eslint-disable-next-line no-console
            console.log('Socket stats', socket.monitor.getFinalStats())
        })

        this.mediumLatency = createDivIn(this.container, 'hidden')
        this.mediumLatency.title = 'Medium latency pings'
        this.mediumLatency.style.marginRight = '5px'
        this.mediumLatency.style.color = 'orange'

        this.highLatency = createDivIn(this.container, 'hidden')
        this.highLatency.title = 'High latency pings'
        this.highLatency.style.marginRight = '5px'
        this.highLatency.style.color = 'red'

        this.droppedLatency = createDivIn(this.container, 'hidden')
        this.droppedLatency.title = 'Dropped pings'
        this.droppedLatency.style.marginRight = '5px'
        this.droppedLatency.style.color = 'red'

        this.reconnects = createDivIn(this.container, 'hidden')
        this.reconnects.title = 'Reconnects'
        this.reconnects.style.marginRight = '5px'
        this.reconnects.style.color = 'red'

        this.latency = createDivIn(this.container, '')
        this.latency.title = 'Last latency reading'
        this.latency.style.minWidth = '65px'
        this.latency.style.textAlign = 'right'
    }

    private update() {
        const stats = socket.monitor.stats

        this.mediumLatency.textContent = `${stats.medium}`
        this.mediumLatency.classList.toggle('hidden', stats.medium == 0)

        this.highLatency.textContent = `${stats.high}`
        this.highLatency.classList.toggle('hidden', stats.high == 0)

        this.droppedLatency.textContent = `${stats.dropped}`
        this.droppedLatency.classList.toggle('hidden', stats.dropped == 0)

        this.reconnects.textContent = `${stats.reconnects}`
        this.reconnects.classList.toggle('hidden', stats.reconnects == 0)

        const lastLatency = Math.ceil(socket.monitor.lastLatency / 10) * 10
        this.latency.textContent = `${lastLatency}ms`
    }
}

window['startSocketMonitor'] = () => {
    const monitor = new UISocketMonitor()
    monitor.start()

    return monitor
}
